<script>
export default {
  props: {
    modal: {}
  },
  mounted () {
    this.$emit('onRef', {
      refresh: this.refresh
    })
  },
  methods: {
    awaitModal () {
      return new Promise((resolve) => {
        let cont = 0
        let int = setInterval(() => {
          if (this.$refs.modalRef || cont === 10) {
            clearInterval(int)
            return resolve()
          }
          cont++
        }, 100)
      })
    },
    async refresh (...params) {
      await this.awaitModal()
      return this.$refs.modalRef.refresh(...params)
    },
    cancel (...params) {
      this.$emit('cancel', ...params)
    },
    save (...params) {
      this.$emit('save', ...params)
    }
  }
}
</script>

<template>
  <div>
    <component
      ref="modalRef"
      v-if="modal.render"
      :is="modal.component"
      :mode="modal.mode"
      @cancel="cancel"
      @save="save"
      />
  </div>
</template>
